var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"pay-plan-period-state-badge",class:[
    `pay-plan-period-state-badge--${_setup.normalized}`,
    _vm.filled ? 'pay-plan-period-state-badge--filled' : 'pay-plan-period-state-badge--outline',
  ]},[_c('span',{staticClass:"pay-plan-period-state-badge__dot",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_setup.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }